/**
 * App version. Bump on every deploy per
 * `1. Guides/CHANGELOG_PROCESS.md` §3. Mirrors the newest CHANGELOG.md
 * entry.
 *
 * No service worker in this app (it's an internal admin tool), so
 * there's no cache-name to bump alongside.
 */
export const APP_VERSION = 'v0.8.8';
